'use strict';

var Params = function Params(dataLength) {
  return function (containerWidth) {
    var padding = {
      top: 25.5,
      bottom: 35.5,
      left: -1,
      right: 0.5
    };
    var width = containerWidth - (padding.left + padding.right);
    var barHeight = 25;
    var height = barHeight * dataLength;
    return {
      width: width,
      forceHeight: true,
      height: height,
      containerWidth: containerWidth,
      containerHeight: height + padding.top + padding.bottom,
      padding: padding,
      xAxisShift: 0,
      direction: 'vertical',
      yAxisShift: 0
    };
  };
};
module.exports = Params;